import React, { useState, useEffect, useRef } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography"
import { MonthlyProgressBlock } from "../components/Dashboard/MonthlyProgressBlock"
import { useDispatch } from 'react-redux';
import { processFetchingDashboardDetails } from "../redux-store/dashboardSlice/dashboardSliceActions"
import { TopFiveBlock } from '../components/Dashboard/TopFiveBlock';
import { PassPercentageBlock } from "../components/Dashboard/PassPercentageBlock"
import { CoursesTotalBlock, SellingCoursesTotalBlock } from '../components/Dashboard/CoursesTotalBlock';
import { PopularCourses } from '../components/Dashboard/PopularCourses';
import { IntroVideoBlock } from '../components/Dashboard/IntroVideoBlock';
import { SlidesBlock } from "../components/Dashboard/SlidesBlock"
import { TopPerformers } from '../components/Dashboard/TopPerformersBlock';
import { TopBanner } from '../components/Dashboard/TopBanner';
import { ContentUsage } from '../components/Dashboard/ContentUsage';
import { styled } from '@mui/material';
import { useScrollToTop } from '../hooks/useScrollToTop';

const DashboardWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    background: "#ffffff",
    overflow: "auto",
    "& .image-gallery-image": {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
    },
    '& video': {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
    },
    [theme.breakpoints.down('md')]: {
        background: "#fafafa",
    },
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
    "& .MuiGrid-item": {
        [theme.breakpoints.down('md')]: {
            paddingLeft: "5px !important",
        }
    },
}));

const StyledGridItem = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        paddingTop: "0px !important",
    },
}));



const LMSDashboard = () => {
    const dispatch = useDispatch()

     const [selectedCourseId, setSelectedCourseId] = useState(null);

     const handleCourseClick = (courseId) => {
        setSelectedCourseId(courseId);
    };

    useScrollToTop()

    React.useEffect(() => {
        dispatch(processFetchingDashboardDetails())
    }, [dispatch])

    return (
    <DashboardWrapper>
        <Box sx={{ my: { xs: 1, md: 4 }, px: { xs: 2, md: 4 } }} >

            {/* ROW 1 */}
            <StyledGrid container spacing={{ xs: 1, md: 3 }} sx={{ mb: { xs: 1, md: 2 } }}>
                <Grid item xs={12} md={6}>
                    <PopularCourses 
                    onCourseClick={handleCourseClick}
                    selectedCourseId={selectedCourseId}/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TopFiveBlock />
                </Grid>
            </StyledGrid>

            {/* ROW 2 */}
            <StyledGrid container spacing={{ xs: 1, md: 3 }}>
                <Grid item xs={12} md={6}>
                    <PassPercentageBlock courseId={selectedCourseId}/>
                </Grid>

                 <Grid item xs={12} md={6}>
                    <TopPerformers courseId={selectedCourseId}/>
                </Grid> 
            </StyledGrid>

        </Box>
    </DashboardWrapper>
);
};


export default LMSDashboard;